import { IAspectRatioHeightData, IWidgetVisibility, VisibilityData, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface ISpacerWidgetData extends IWidgetVisibility {
    readonly type: "SpacerWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    style: ISpacerWidgetStyle | null;
}

export interface ISpacerWidgetStyle extends IAnimatedWidget {
    heightData?: IAspectRatioHeightData | null;
}

export abstract class SpacerWidgetData {

    public static updateWithDefaults(data: ISpacerWidgetData): void {
        data.visibility = this.defaultData.visibility;
        data.style = this.defaultData.style;
    }

    public static get defaultData(): ISpacerWidgetData {
        return {
            type: "SpacerWidget",
            placeType: "Section",
            visibility: VisibilityData.defaultData(),
            style: this.defaultStyle
        };
    }

    public static get defaultStyle(): ISpacerWidgetStyle {
        return {
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            },
            heightData: {
                paddingTop: 25
            }
        };
    }

}
